import { autoinject } from 'aurelia-dependency-injection';
import { CurrenciesClient } from '@dynamik/common/clients/transaction-clients';
import { CacheService } from '@dynamik/common';

@autoinject
export class CurrenciesCache {
  constructor(private currenciesClient: CurrenciesClient, private cacheService: CacheService) { }

  async get() {
    return this.cacheService.getOrSet('currencies', () => this.currenciesClient.get(), 6000000000);
  }
}
